import { createFileRoute } from '@tanstack/react-router';
import { SAssetNew } from '@/screens/SAssetNew/SAssetNew';

export const Route = createFileRoute('/$orgId/assets/new')({
  component: SAssetNew,
});
